export function PageTitle({ title, subtitle, children }) {
  return (
    <div className="flex flex-wrap items-start justify-between gap-4 mb-6">
      <div>
        <h1 className="font-serif text-2xl lg:text-3xl text-navy">{title}</h1>
        {subtitle && <p className="text-slate-500 text-sm mt-1">{subtitle}</p>}
      </div>
      {children}
    </div>
  );
}

export function Card({ title, children, className = "" }) {
  return (
    <div className={`bg-white border border-slate-200 rounded-lg p-6 ${className}`}>
      {title && <h2 className="font-serif text-lg text-navy mb-5 pb-3 border-b border-slate-100">{title}</h2>}
      {children}
    </div>
  );
}

export function Field({ label, children, hint }) {
  return (
    <div className="mb-4">
      <label className="block text-xs font-semibold text-navy mb-1.5 uppercase tracking-wide">{label}</label>
      {children}
      {hint && <p className="text-xs text-slate-400 mt-1">{hint}</p>}
    </div>
  );
}

export const inputCls = "w-full border border-slate-300 rounded-sm px-4 py-2.5 text-sm focus:outline-none focus:border-brass focus:ring-1 focus:ring-brass bg-white";

export function SaveButton({ onClick, saving, label = "Save Changes", testid = "save-btn" }) {
  return (
    <button onClick={onClick} disabled={saving}
      className="bg-brass hover:bg-brass-hover text-navy font-semibold px-6 py-2.5 rounded-sm transition-colors disabled:opacity-60 inline-flex items-center gap-2" data-testid={testid}>
      {saving && <span className="w-4 h-4 border-2 border-navy/40 border-t-navy rounded-full animate-spin" />}
      {label}
    </button>
  );
}
